var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgGraph = function SvgGraph(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.14156 13.7475V6.19039M9.9987 13.7952V9.99992M12.8558 13.8094V8.09516M5.23679 3.33325H14.7606C15.2658 3.33325 15.7503 3.53393 16.1075 3.89114C16.4647 4.24836 16.6654 4.73284 16.6654 5.23801V14.7618C16.6654 15.267 16.4647 15.7515 16.1075 16.1087C15.7503 16.4659 15.2658 16.6666 14.7606 16.6666H5.23679C4.73162 16.6666 4.24714 16.4659 3.88992 16.1087C3.53271 15.7515 3.33203 15.267 3.33203 14.7618V5.23801C3.33203 4.73284 3.53271 4.24836 3.88992 3.89114C4.24714 3.53393 4.73162 3.33325 5.23679 3.33325Z",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgGraph);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "graph.dd9a11dff7ee42cf7e4e8f80b2132bab.svg";